import { Award, GraduationCap, Receipt, User } from 'lucide-react'
import { Outlet } from 'react-router-dom'
import { DashboardShell } from './dashboard-shell'

const NAV_ITEMS = [
  { label: 'My learning', to: '/dashboard', icon: GraduationCap, end: true },
  { label: 'Certificates', to: '/certificates', icon: Award },
  { label: 'Orders', to: '/orders', icon: Receipt },
  { label: 'Profile', to: '/profile', icon: User },
]

export function LearnerLayout() {
  return (
    <DashboardShell navItems={NAV_ITEMS}>
      <Outlet />
    </DashboardShell>
  )
}
